var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActuator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36Z",
    fill: "#828FAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 13C11.3458 13 10 11.6543 10 10.0001C10 8.34583 11.3458 7 13.0001 7C14.6543 7 16 8.34583 16 10.0001C16 11.6543 14.6543 13 13.0001 13ZM13.0001 7.90001C11.842 7.90001 10.9 8.84198 10.9 10.0001C10.9 11.158 11.842 12.1 13.0001 12.1C14.158 12.1 15.1 11.158 15.1 10.0001C15.1 8.84198 14.158 7.90001 13.0001 7.90001Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6 28.7999C20.9458 28.7999 19.6 27.4542 19.6 25.7999C19.6 24.1457 20.9458 22.7999 22.6 22.7999C24.2543 22.7999 25.6 24.1457 25.6 25.7999C25.6 27.4542 24.2543 28.7999 22.6 28.7999ZM22.6 23.6999C21.442 23.6999 20.5 24.6419 20.5 25.7999C20.5 26.9579 21.442 27.8999 22.6 27.8999C23.758 27.8999 24.7 26.9579 24.7 25.7999C24.7 24.6419 23.758 23.6999 22.6 23.6999Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9458 16.3877C21.9456 15.8031 21.4718 15.3291 20.8872 15.3291H13.4751V19.5644C13.4751 20.149 13.9491 20.6228 14.5337 20.623V21.6826L14.3179 21.6709C13.2499 21.5625 12.4165 20.6609 12.4165 19.5644V14.2705H20.8872L21.104 14.2812C22.1715 14.3898 23.0042 15.2916 23.0044 16.3877V21.6826H14.5337V20.623H21.9458V16.3877Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4167 12.682L13.4753 12.682L13.4753 15.8587L12.4167 15.8587L12.4167 12.682Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.95 21L23.01 21L23.01 23.7L21.95 23.7L21.95 21Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActuator);
export default __webpack_public_path__ + "static/media/actuator.7b954629a7784aab4467becc6460bab6.svg";
export { ForwardRef as ReactComponent };